module.exports = __webpack_public_path__ + "img/logo-steam.b35de5ad.svg";